function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 339 411",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M178.652,318.049c6.731,0 9.537,9.65 -0.136,10.764c-4.689,0.54 -9.112,0.63 -13.658,0.63c-19.399,0 -38.721,-3.258 -57.969,-9.775c-19.247,-6.517 -36.6,-16.519 -52.058,-30.007c-15.458,-13.488 -27.961,-30.538 -37.509,-51.149c-9.548,-20.611 -14.322,-45.011 -14.322,-73.199c0,-23.339 3.94,-44.935 11.821,-64.788c7.881,-19.853 18.868,-36.979 32.963,-51.376c14.094,-14.397 31.144,-25.688 51.149,-33.872c20.005,-8.184 41.98,-12.276 65.925,-12.276c19.096,0 38.267,3.334 57.514,10.002c19.247,6.668 36.524,16.746 51.831,30.235c15.307,13.488 27.734,30.538 37.282,51.149c9.548,20.611 14.322,44.859 14.322,72.745c0,23.642 -3.486,44.556 -10.457,62.742c-6.644,17.332 -16.644,33.882 -22.415,38.47c-4.735,3.765 -16.198,-2.683 -11.702,-13.355c1.885,-4.476 3.646,-10.305 3.655,-10.339c4.243,-14.701 6.062,-30.538 5.456,-47.511c-0.909,-23.642 -5.077,-46.526 -12.503,-68.653c-7.426,-22.127 -17.504,-41.753 -30.235,-58.878c-12.73,-17.125 -27.734,-30.765 -45.011,-40.919c-17.277,-10.154 -36.069,-15.231 -56.377,-15.231c-17.277,0 -32.659,3.031 -46.148,9.093c-13.488,6.062 -24.854,14.625 -34.099,25.688c-9.245,11.063 -16.14,24.324 -20.687,39.782c-4.547,15.458 -6.517,32.432 -5.911,50.921c0.909,22.733 5.077,44.859 12.503,66.38c7.426,21.52 17.58,40.616 30.462,57.287c12.882,16.671 27.961,30.083 45.238,40.237c17.277,10.154 30.768,15.204 51.076,15.204Z",
    style: {
      fill: "#040404",
      stroke: "#040404",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.19,318.738c47.644,61.214 79.342,76.421 66.216,88.969c-11.697,11.182 -23.602,-13.272 -42.547,-37.872c-5.809,-7.543 -38.173,-50.639 -49.541,-54.586c-14.388,-4.996 -16.951,-2.428 -30.065,-21.247c-18.67,-26.793 -22.158,-31.417 -20.878,-32.698c2.997,-2.997 29.835,38.217 33.844,35.176c3.749,-2.844 -12.846,-20.998 -21.028,-32.278c-1.494,-2.059 -7.335,-8.676 -4.628,-9.048c3.261,-0.448 13.825,14.778 29.233,31.302c3.154,3.383 4.594,2.51 5.107,1.948c3.453,-3.783 -29.749,-36.901 -27.302,-39.31c1.838,-1.81 3.406,2.112 29.432,28.659c0.379,0.386 5.288,5.4 6.883,3.805c3.483,-3.483 -31.547,-36.599 -29.077,-39.356c1.648,-1.839 4.146,1.571 29.904,27.836c15.419,15.722 12.575,17.657 14.499,29.377c1.42,8.652 3.028,9.87 9.948,19.323Z",
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.62,289.334c2.231,15.115 2.095,15.75 11.967,25.177c18.323,17.499 60.824,53.523 52.052,64.334c-10.504,12.947 -51.762,-50.382 -73.75,-74.895c-5.104,-5.69 -60.466,-67.407 -63.099,-71.751c-6.305,-10.403 29.901,6.033 53.911,29.696c17.53,17.277 16.24,18.59 18.92,27.439Z",
    style: {
      fill: "url(#_Linear2)"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(102.480561,124.00891,-124.00891,102.480561,190.927035,270.215649)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e9c465",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#caa141",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#bf9535",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#bf9332",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#cfa441",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#d4a94b",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e2b764",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(132.93734,147.255928,-160.844659,145.204756,202.963155,231.267264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e9c465",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#deb859",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#bf9535",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#bf9332",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#cfa441",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#e1ba5a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e9c465",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQBlack);
export default __webpack_public_path__ + "static/media/QBlack.a00e0f6a1bb186fc66432eaa6300ea5d.svg";
export { ForwardRef as ReactComponent };